import { IBusinessSettingVM, IReservationSettingVM } from "../../models/response/IMasterManagementResponse";
import { IBusinessTypeState, IConsumptionTaxState, IMotivationInStoreState, IMotivationState, IPaymentInStoreState, IPaymentState, ITaxState, ITimeState } from "../../models/state/IMasterSettingsState";

export const businessTypeInitialState: IBusinessTypeState = {
  Id: -1,
  BusinessType: "",
  Description: "",
};


export const taxInitialState: ITaxState = {
  Id: -1,
  TaxValue: 0,
  Description: "",
};

export const timeInitialState: ITimeState = {
  Id: -1,
  Time: 0,
  Description: "",
};


export const motivationInitialState: IMotivationState = {
  Id: -1,
  MotivationName: "",
  Description: "",
};

export const paymentInitialState: IPaymentState = {
  Id: -1,
  Name: "",
  Description: "",
};

export const businessSettingInitialState: IBusinessSettingVM = {
  StoreId: -1,
  WeekDays: 0,
  IsClosed: false,
  OpenTime: null,
  ClosedTime: null,
};

export const reservationSettingInitialState: IReservationSettingVM = {
  StoreId: -1,
  CancelationTime: "",
  NewReservationTime: "",
  IntervalTime: "",
  SeatAvailable: "",
  CalendarIntervalTime: "",
  BusinessSettings: [],
  Precaution: "",
  EmailNotifyToStore: false,
};

export const consumptionTaxInitialState: IConsumptionTaxState = {
  Id: -1, 
  TaxValue: 0,
  HeadquarterId: 0, 
};

export const motivationInStoreInitialState: IMotivationInStoreState = {
  Id: -1,
  MotiveId: 0,
  StoreId: 0,
};

export const paymnetInStoreInitialState: IPaymentInStoreState = {
  Id: -1,
  PaymentModeId: 0,
  StoreId: 0,
};